<template>
    <div class="slider-reviews" :class="className">
        <div class="home-heading">
            <h2>Επαγγελματίες πελάτες μας είπαν για εμάς</h2>
        </div>
        <swiper class="slider-reviews-carousel" :slides-per-view="1" :space-between="60" :navigation="true" :loop="true" :modules="modules" :breakpoints="breakpointsReviews">
            <swiper-slide v-for="(review, index) in reviews" :key="index">
                <div class="slider-reviews-item">
                    <div class="slider-reviews-carousel-stars">
                        <Star v-for="(key) in review.star" :key="`${key}-star`" active/>
                        <Star v-if="review !== 5" v-for="(key) in (5 - review.star)" :key="`${key}-not-star`"/>
                    </div>
                    <h3>{{ review.text }}</h3>
                    <h4>{{ review.name }}</h4>
                    <p>{{ review.job }}</p>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import { Star } from "../../Icons/Icons";
    import { Swiper, SwiperSlide } from "swiper/vue";
    import { Navigation } from "swiper";
    import "swiper/css";

    export default {
        components: {
            Swiper, SwiperSlide,
            Star,
        },
        props: {
            className: String
        },
        setup() {
            const reviews = [
                { text: 'Αγόρασα από τον AutoBesikos ένα Peugeot Partner και είμαι απόλυτα ευχαριστημένος. Το αυτοκίνητο ήταν σε άψογη κατάσταση, με πλήρες ιστορικό service και εγγύηση. Η εξυπηρέτηση ήταν επαγγελματική και άμεση με βοήθησαν σε όλη τη διαδικασία χρηματοδότησης χωρίς καμία ταλαιπωρία', name: 'Γιώργος Κ.', job: 'Επαγγελματίας', star: 5 },
                { text: 'Έψαχνα αξιόπιστο van και ο AutoBesikos μου πρότεινε το ιδανικό Fiat Fiorino. Ειλικρινείς, φιλικοί και με άψογη εξυπηρέτηση. Η αγορά έγινε γρήγορα, το αυτοκίνητο παραδόθηκε πεντακάθαρο και έτοιμο για δουλειά. Τους προτείνω ανεπιφύλακτα!', name: 'Μαρία Π.', job: 'Επαγγελματίας', star: 5 },
                { text: 'Είχα συνεργαστεί ξανά με τον AutoBesikos στο παρελθόν, οπότε ήξερα τι να περιμένω. Αυτή τη φορά πήραμε δύο επαγγελματικά Dacia Dokker. Εξαιρετική ποιότητα και επαγγελματισμός από την πρώτη μέχρι την τελευταία στιγμή.', name: 'Σπύρος Δ.', job: 'Επαγγελματίας', star: 5 },
                { text: 'Ήθελα κάτι αξιόπιστο και οικονομικό. Με καθοδήγησαν τέλεια και κατέληξα σε ένα Citroën Nemo. Το έχω 6 μήνες, κανένα πρόβλημα! Ο AutoBesikos αποδεικνύει γιατί έχει τόσα χρόνια εμπειρίας στο χώρο.', name: 'Νίκος Α.', job: 'Επαγγελματίας', star: 5 },
                { text: 'Είδαν τις ανάγκες μου και μου πρότειναν ένα Opel Combo που καλύπτει τα πάντα, από χώρο φόρτωσης μέχρι κατανάλωση. Όλη η ομάδα είναι επαγγελματίες και πραγματικά νοιάζονται για τον πελάτη.', name: 'Δημήτρης Μ.', job: 'Επαγγελματίας', star: 5 },
            ]
            return { reviews, modules: [Navigation] }
        },
        computed: {
            breakpointsReviews() {
                return {
                    '1200': { slidesPerView: 3 },
                    '800': { slidesPerView: 2 },
                    '400': { slidesPerView: 1 },
                }
            },
        },
    }
</script>